<template>
    <va-inner-loading :loading="isLoading" style="width: 100%" color="primary">
        <div class="grid row posts-content">
            <div class="flex xs12 md12">
                <div class="flex x12 md12 xs12">
                    <vxe-form
                        :data="toolbar.formData"
                        :rules="formRules"
                        @submit="publishPosts"
                    >
                        <vxe-form-item
                            title="板块"
                            field="plateVal"
                            :item-render="{}"
                            span="6"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.plateVal"
                                    placeholder="请选择板块"
                                >
                                    <vxe-option
                                        v-for="(item, index) in plateOption"
                                        :key="index"
                                        :value="item"
                                        :label="item.Name"
                                    >
                                    </vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            span="18"
                            title="标题"
                            field="postsTitle"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    clearable
                                    v-model="data.postsTitle"
                                    maxlength="200"
                                    placeholder="小伙伴们请注意：标题只能显示200个字哦！"
                                >
                                </vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="标签"
                            field="biaoqian"
                            :item-render="{}"
                            span="12"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    clearable
                                    v-model="data.biaoqian"
                                    style="display: none"
                                >
                                </vxe-input>
                                <a-select
                                    mode="multiple"
                                    allowClear
                                    v-model:value="data.biaoqian"
                                    notFoundContent="暂无数据"
                                    optionLabelProp="label"
                                    placeholder="请选择选项"
                                    :options="
                                        options.map((item) => ({
                                            label: item.Name,
                                            value: item.ID,
                                        }))
                                    "
                                    style="width: 100%"
                                >
                                </a-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="分类"
                            field=""
                            :item-render="{}"
                            span="12"
                        >
                            <template #default="{ data }">
                                <a-cascader
                                    :show-search="{ selectFilter }"
                                    v-model:value="data.fenlei2"
                                    @change="handleChange"
                                    style="width: 100%"
                                    placeholder="请选择分类"
                                    notFoundContent="暂无数据"
                                    :options="classOptions"
                                    change-on-select
                                    :fieldNames="{
                                        label: 'Name',
                                        value: 'ID',
                                        children: 'Children',
                                    }"
                                />
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="24" :item-render="{}">
                            <template #default="">
                                <div>
                                    <!-- <QuillEditor ref="quill" toolbar="full" /> -->

                                    <articleEditor
                                        v-model="articleContent"
                                    ></articleEditor>
                                </div>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item style="padding: 0">
                            <template #default="{ data }">
                                <!-- <div>
                    <vxe-button status="primary" @click="insertEvent(false)">选择文件</vxe-button>
                    <span style="margin-left:10px;">{{data.FileName}}</span><span class="del-btn" v-if="data.FileName != null && data.FileName != ''" @click="delClick">删除</span>
                  </div> -->
                                <div>
                                    <vxe-button
                                        status="primary"
                                        @click="insertEvent(false)"
                                        >选择文件</vxe-button
                                    >

                                    <span style="margin-left: 10px">{{
                                        data.FileName
                                    }}</span
                                    ><span
                                        class="del-btn"
                                        v-if="
                                            data.FileName != null &&
                                            data.FileName != ''
                                        "
                                        @click="delClick"
                                        >删除</span
                                    >
                                    <div
                                        style="
                                            display: inline-block;
                                            height: 20px;
                                        "
                                        v-if="
                                            data.FileName != null &&
                                            data.FileName != '' &&
                                            isVideo
                                        "
                                    >
                                        是否播放：
                                        <vxe-select
                                            v-model="setStateValue"
                                            placeholder="请选择"
                                            style="margin-bottom: 20px"
                                        >
                                            <vxe-option
                                                value="1"
                                                label="是"
                                            ></vxe-option>
                                            <vxe-option
                                                value="0"
                                                label="否"
                                            ></vxe-option>
                                        </vxe-select>
                                    </div>
                                </div>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="24">
                            <template #default="">
                                <!-- <va-button class="flex xs14 msg-submit" @click="publishPosts" :rounded="false" text-color="#ffffff">发布帖子</va-button> -->
                                <vxe-button
                                    type="submit"
                                    class="msg-submit"
                                    status="primary"
                                    content="修改帖子"
                                >
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
            </div>
        </div>
    </va-inner-loading>
</template>
<script>
import { defineComponent, ref, reactive, getCurrentInstance } from "vue";
import { VXETable, VxeFormEvents, VxeFormPropTypes } from "vxe-table";
import Qs from "qs";
import articleEditor from "../forum/components/articleEditor.vue";

export default {
    name: "articleCompile",
    props: {
        searcharticle: {
            type: Number,
            required: true,
        },
    },
    components: { articleEditor },
    watch: {
        searcharticle: {
            immediate: true,
            handler(val) {
                this.getForumSection();
            },
        },
    },
    data() {
        const selectFilter = (inputValue, path) => {
            return path.some(
                (option) =>
                    option.label
                        .toLowerCase()
                        .indexOf(inputValue.toLowerCase()) > -1
            );
        };
        const { proxy } = getCurrentInstance();
        const options = proxy.$store.state.tabOptions,
            classOptions = proxy.$store.state.classOptions;
        const popupScroll = () => {
            console.log("popupScroll");
        };
        const toolbar = reactive({
            loading: false,
            formData: {
                postsTitle: "",
                searchStatus: "",
                plateVal: ref(),
                biaoqian: ref(),
                fenlei2: ref(),
                FileName: null,
            },
        });
        const formRules = {
            plateVal: [{ required: true, message: "请选择分类" }],
            biaoqian: [
                { required: true, message: "请选择标签" },
                {
                    validator({ itemValue }) {
                        console.log(itemValue);
                        // 自定义校验
                        if (itemValue == undefined) {
                            return new Error("请选择标签");
                        }
                        if (itemValue.length == 0) {
                            return new Error("请选择标签");
                        }
                    },
                },
            ],
            fenlei2: [{ required: true, message: "请选择分类" }],
            postsTitle: [{ required: true, message: "请填写标题" }],
            // contents: [{ required: true, message: '请填写内容' }]
        };
        const handleChange = (value) => {
            console.log(value);
        };
        return {
            isLoading: false,
            articleCompileId: "",
            dataList: {},
            selectFilter,
            handleChange,
            options,
            classOptions,
            formRules,
            toolbar,
            popupScroll,
            size: ref("default"),
            oneFile: null,
            isDel: false,
            articleContent: null, //文章内容
            pushEditorData: null,
            pushEditorHeight: 0,
            isVideo: false,
            setStateValue: ""
        };
    },

    methods: {
        getEditorContent(conetntHtml) {
            this.articleContent = conetntHtml;
        },
        delClick() {
            this.setStateValue = "";
            this.isVideo = false;
            this.isDel = true;
            this.toolbar.formData.FileName = "";
            this.toolbar.formData.FilePath = "";
        },
        findData(findParam) {
            let params = {
                uid: this.$store.state.userID,
                ArticleId: this.searcharticle,
            };
            this.$api.formsAPI
                .getArticleByUser(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.toolbar.formData = res.data.Data.article;
                    console.log(res.data.Data);
                    console.log(this.plateOption);
                    // this.toolbar.formData.plateVal = {ID:1}
                    let plateFilter = this.plateOption.filter((item, index) => {
                        return res.data.Data.article.SectionID == item.ID;
                    });
                    let labelList,
                        labelArr = [];
                    if (res.data.Data.article.LabelID != null) {
                        labelList = res.data.Data.article.LabelID.split(",");
                        for (let idx = 0; idx < labelList.length; idx++) {
                            if (labelList[idx] != "") {
                                labelArr.push(Number(labelList[idx]));
                            }
                        }
                    }

                    if (res.data.Data.article["CateLabel"] != null) {
                        let fenleiList =
                                res.data.Data.article["CateLabel"].split(","),
                            fenleiArr = [];
                        for (let idx = 0; idx < fenleiList.length; idx++) {
                            if (fenleiList[idx] != "") {
                                fenleiArr.push(Number(fenleiList[idx]));
                            }
                        }
                        this.toolbar.formData.fenlei2 = fenleiArr; //分类赋值
                    }
                    console.log(plateFilter[0]);
                    console.log(this.toolbar.formData.plateVal);

                    // const quill = this.$refs.quill;

                    this.$nextTick(function () {
                        this.toolbar.formData.biaoqian = labelArr; //标签赋值
                        this.toolbar.formData.plateVal = plateFilter[0]; //板块赋值
                        this.toolbar.formData.postsTitle =
                            res.data.Data.article.Title; //标题赋值
                        // quill.setHTML(this.toolbar.formData.Contents);
                        this.articleContent = this.toolbar.formData.Contents;
                        console.log(this.articleContent);
                        this.setStateValue = res.data.Data.article.IsPlay;
                        this.getExtension(res.data.Data.article.FileName);
                        this.pushEditorHeight = "268";
                    });
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //获取板块选项
        getForumSection(paramData) {
            this.isLoading = true;
            let resData,
                totalArticle = 0,
                totalReply = 0;
            const params = {
                Name: "",
            };
            this.$api.formsAPI
                .getForumSection(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    let arr = [
                        { value: "", Name: "全部板块", IsTab: "", ID: "" },
                    ];
                    resData = res.data.Data;
                    resData.map((item, index) => {
                        // console.log(item.ArticleCount)
                        totalArticle += Number(item.ArticleCount);
                        totalReply += Number(item.ReplyCount);
                    });
                    // this.plateOption = [...arr,...resData];
                    this.plateOption = resData;
                    this.totalArticle = totalArticle;
                    this.totalReply = totalReply;
                    this.findData();
                    console.log(this.plateOption);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //发布帖子
        publishPosts() {
            const fenLeiVal = this.toolbar.formData.fenlei2;
            const fData = new FormData();
            // const quill = this.$refs.quill;
            // let quillHtml = quill.getHTML();
            // if(quillHtml == '<p><br></p>'){
            //   VXETable.modal.message({ content: '请填写内容！', status: 'warning' })
            //   return false;
            // }
            if (this.setStateValue == "" && this.isVideo) {
                VXETable.modal.message({
                    content: "请选择附件是否可以播放字段！",
                    status: "warning",
                });
                return false;
            }
            if (this.articleContent == null || this.articleContent == "") {
                VXETable.modal.message({
                    content: "请填写内容！",
                    status: "warning",
                });
                return false;
            }
            // console.log(quillHtml)
            console.log(fenLeiVal);
            fData.append("ID", this.searcharticle); //帖子ID
            fData.append("SectionID", this.toolbar.formData.plateVal.ID); //版块ID
            fData.append("Title", this.toolbar.formData.postsTitle); //标题
            fData.append("Contents", encodeURIComponent(this.articleContent)); //内容
            // fData.append('Creator',this.$store.state.userID);//不传
            // fData.append('CreateTime', files[0]);//可不传
            fData.append("Modifer", this.$store.state.userID); //修改人UID
            // fData.append('ModiferTime', files[0]);//可不传
            // fData.append('IsElite',0);//1 精华 0 非精华
            // fData.append('IsTop',0);//1 置顶 0 非置顶
            fData.append("IsPlay", this.isVideo ? this.setStateValue : 0); //是否可播放
            fData.append(
                "IsSys",
                this.$store.state.isAdmin == 1 ? this.$store.state.isAdmin : ""
            ); //1 系统管理员发布 0 非系统管理员发布
            // fData.append('Enabled', files[0]);//可不传
            fData.append("CateID", fenLeiVal[fenLeiVal.length - 1]); //类别ID只传一个选父级就传父级id，选子级就传子级id  this.toolbar.formData.fenlei2  == undefined ? '' : this.toolbar.formData.fenlei2.join(',')

            fData.append(
                "LabelID",
                this.toolbar.formData.biaoqian == undefined
                    ? ""
                    : this.toolbar.formData.biaoqian.join(",")
            ); //标签ID，多个用','隔开
            fData.append(
                "CateLabel",
                fenLeiVal == undefined ? "" : fenLeiVal.join(",")
            ); //类别ID列表
            fData.append("IsDelFile", Number(this.isDel)); //2更新 1删除
            fData.append(
                "file",
                this.isDel ? "" : this.toolbar.formData.FilePath
            ); //不传
            this.$api.formsAPI
                .updateForumArticleWithFile(fData)
                .then((res2) => {
                    if (res2.data.Success == false) {
                        VXETable.modal.message({
                            content: res2.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    VXETable.modal.message({
                        content: "修改成功",
                        status: "success",
                    });
                    this.$emit("amendArticle", true);
                    // console.log(res2)
                    // this.$router.push({path:'/admin/forum/postsPage/index'})
                    // this.findData();
                })
                .catch((error2) => {
                    VXETable.modal.alert({ content: error2, status: "error" });
                    console.log(error2);
                });

            // VXETable.modal.message({ content: '发布成功！', status: 'success' })
        },
        async insertEvent() {
            const { files } = await VXETable.readFile(false);
            Array.from(files).map((file) => {
                this.toolbar.formData.FileName = file.name;
                this.toolbar.formData.FilePath = file;
                this.isDel = false;
                this.getExtension(file.name);
            });
        },
        //验证是否视频格式
        getExtension(name) {
            if (name == null || name == "" || name == undefined) {
                return false;
            }
            let geshi = [
                    "avi",
                    "flv",
                    "mpg",
                    "mpeg",
                    "mpe",
                    "m1v",
                    "m2v",
                    "mpv2",
                    "mp2v",
                    "dat",
                    "ts",
                    "tp",
                    "tpr",
                    "pva",
                    "pss",
                    "mp4",
                    "m4v",
                    "wmv",
                    "swf",
                    "mp3",
                    "wma",
                    "mkv",
                    "m4p",
                    "m4b",
                    "3gp",
                    "3gpp",
                    "3g2",
                    "3gp2",
                    "ogg",
                    "mov",
                    "qt",
                    "amr",
                    "rm",
                    "ram",
                    "rmvb",
                    "rpm",
                ],
                mingzi = name.substring(name.lastIndexOf(".") + 1);
            for (let i = 0; i < geshi.length; i++) {
                if (geshi[i] == mingzi) {
                    this.isVideo = true;
                }
            }
            // console.log(this.isVideo)
        },
    },
};
</script>
<style src="../forum/css/antd.css"></style>
<style>
.inner-loading__spinner {
    -webkit-animation: va-icon--spin-animation 1.5s linear infinite;
    animation: va-icon--spin-animation 1.5s linear infinite;
    animation-direction: reverse;
}

@-webkit-keyframes va-icon--spin-animation {
    0% {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(1turn);
    }
}

@keyframes va-icon--spin-animation {
    0% {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(1turn);
    }
}
</style>
<style scoped>
::v-deep .ql-container {
    height: 200px;
}

.del-btn {
    margin: 0 10px;
    color: #1890ff;
    text-decoration: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;
}

.msg-submit {
    border-radius: unset;
    margin: 10px 0px 0px auto;
    display: block;
}
</style>
